export default "__VITE_ASSET__82e0e784__"